import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineClose } from "react-icons/ai";

export default function UserCardModal({
  open,
  setOpen,
  cancelButtonRef,
  user,
}) {
  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div>
                      <div className="">
                        <div className="mb-6 bg-gray-800 p-4 rounded-t-xl">
                          <div className="flex text-xl items-center text-white">
                            <AiOutlineClose
                              onClick={() => setOpen(false)}
                              className="cursor-pointer"
                            />
                            <div className="ml-auto mr-auto font-bold">
                              User Card
                            </div>
                          </div>
                        </div>
                        <div className="text-lg">{user?.bio}</div>
                        <div>
                          <div className="flex justify-center my-5">
                            <img
                              className="w-32 h-32 rounded-full mr-4"
                              src={user?.profileImage}
                              alt="profile picture"
                            />
                          </div>
                          <div className="font-bold text-2xl">
                            {user?.fullName}
                          </div>
                          <div className="text-xl">
                            {user?.emailAddress === user?.matricNumber
                              ? null
                              : user?.emailAddress}
                          </div>
                          <div className="text-lg">{user?.matricNumber}</div>
                          <div className="text-lg">{user?.program}</div>
                          <div className="text-lg">{user?.graduationYear}</div>
                          <div className="text-lg">{user?.setName}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
